import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { LeadTypeaheadComponent } from './lead-typeahead.component';

@NgModule({
    imports: [
        SharedModule,
        TypeaheadModule
    ],
    declarations: [
        LeadTypeaheadComponent
    ],
    exports: [
        LeadTypeaheadComponent
    ]
})
export class LeadTypeaheadModule { }
